module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "button-return",
    class: {
      disabled: _vm.noshow === true
    },
    on: {
      "click": _vm.back
    }
  }, [_c('img', {
    attrs: {
      "src": "media/global/btn_return.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "button-title"
  }, [_vm._v(_vm._s(this.$store.state.items.buttons.returnButton))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e1ae91c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ButtonReturn.vue
// module id = 143
// module chunks = 0